import {IAgencyCostLineItemImperial, LineItemTypes, MainlineOptions} from '@/modules/agencyCost/interfaces/agencyCost';
import {ImperialUnits} from '@/lib/unitConversion/unitConversionFactors';
import {UnitSystem} from '@/interfaces/units';

export const discountRateDefault = 0.04;


export const defaultLineItems: IAgencyCostLineItemImperial[] = [
  /*
  AC Pavement mix
   */
  {
    id: null,
    name: 'Asphalt Friction Course',
    activity: null,
    unitCost: 145.58,
    unitSystem: UnitSystem.Imperial,
    displayUnits: UnitSystem.Imperial,
    units: ImperialUnits.MASS_SHTN,
    density_lbPerFt3: 146,
    width_ft: null,
    thickness_in: null,
    mainline: MainlineOptions.BOTH,
    isDefault: true,
    fromDefault: true,
    description: null,
    quantity: null,
    type: LineItemTypes.HARDCOST,
  },
  {
    id: null,
    name: 'Asphalt Surface Course',
    activity: null,
    unitCost: 78.48,
    unitSystem: UnitSystem.Imperial,
    displayUnits: UnitSystem.Imperial,
    units: ImperialUnits.MASS_SHTN,
    density_lbPerFt3: 146,
    width_ft: null,
    thickness_in: null,
    mainline: MainlineOptions.BOTH,
    isDefault: true,
    fromDefault: true,
    description: null,
    quantity: null,
    type: LineItemTypes.HARDCOST,
  },
  {
    id: null,
    name: 'Asphalt Binder/Intermediate Course',
    activity: null,
    unitCost: 80.91,
    unitSystem: UnitSystem.Imperial,
    displayUnits: UnitSystem.Imperial,
    units: ImperialUnits.MASS_SHTN,
    density_lbPerFt3: 146,
    width_ft: null,
    thickness_in: null,
    mainline: MainlineOptions.BOTH,
    isDefault: true,
    fromDefault: true,
    description: null,
    quantity: null,
    type: LineItemTypes.HARDCOST,
  },
  {
    id: null,
    name: 'Asphalt Base Course',
    activity: null,
    unitCost: 73.32,
    unitSystem: UnitSystem.Imperial,
    displayUnits: UnitSystem.Imperial,
    units: ImperialUnits.MASS_SHTN,
    density_lbPerFt3: 146,
    width_ft: null,
    thickness_in: null,
    mainline: MainlineOptions.BOTH,
    isDefault: true,
    fromDefault: true,
    description: null,
    quantity: null,
    type: LineItemTypes.HARDCOST,
  },
  {
    id: null,
    name: 'Cold Central Plant Recycled Asphalt Base',
    activity: null,
    unitCost: 50.00,
    unitSystem: UnitSystem.Imperial,
    displayUnits: UnitSystem.Imperial,
    units: ImperialUnits.MASS_SHTN,
    density_lbPerFt3: 146,
    width_ft: null,
    thickness_in: null,
    mainline: MainlineOptions.BOTH,
    isDefault: true,
    fromDefault: true,
    description: null,
    quantity: null,
    type: LineItemTypes.HARDCOST,
  },
  {
    id: null,
    name: 'Cold In-Place Recycling',
    activity: null,
    unitCost: 12.50,
    unitSystem: UnitSystem.Imperial,
    displayUnits: UnitSystem.Imperial,
    units: ImperialUnits.VOLUME_YD2IN,
    density_lbPerFt3: 146,
    width_ft: null,
    thickness_in: null,
    mainline: MainlineOptions.BOTH,
    isDefault: true,
    fromDefault: true,
    description: null,
    quantity: null,
    type: LineItemTypes.HARDCOST,
  },
  {
    id: null,
    name: 'SMA Surface',
    activity: null,
    unitCost: 116.39,
    unitSystem: UnitSystem.Imperial,
    displayUnits: UnitSystem.Imperial,
    units: ImperialUnits.MASS_SHTN,
    density_lbPerFt3: 146,
    width_ft: null,
    thickness_in: null,
    mainline: MainlineOptions.BOTH,
    isDefault: true,
    fromDefault: true,
    description: null,
    quantity: null,
    type: LineItemTypes.HARDCOST,
  },
  {
    id: null,
    name: 'SMA Intermediate',
    activity: null,
    unitCost: 102.18,
    unitSystem: UnitSystem.Imperial,
    displayUnits: UnitSystem.Imperial,
    units: ImperialUnits.MASS_SHTN,
    density_lbPerFt3: 146,
    width_ft: null,
    thickness_in: null,
    mainline: MainlineOptions.BOTH,
    isDefault: true,
    fromDefault: true,
    description: null,
    quantity: null,
    type: LineItemTypes.HARDCOST,
  },
  {
    id: null,
    name: 'Asphalt Tack Coat',
    activity: null,
    unitCost: 102.18,
    unitSystem: UnitSystem.Imperial,
    displayUnits: UnitSystem.Imperial,
    units: ImperialUnits.VOLUME_GAL,
    density_lbPerFt3: null,
    width_ft: null,
    thickness_in: null,
    mainline: MainlineOptions.BOTH,
    isDefault: true,
    fromDefault: true,
    description: null,
    quantity: null,
    type: LineItemTypes.HARDCOST,
  },


  /*
  Concrete pavement area
   */

  {
    id: null,
    name: 'Joint Plain Concrete Slab',
    activity: null,
    unitCost: 55.00,
    unitSystem: UnitSystem.Imperial,
    displayUnits: UnitSystem.Imperial,
    units: ImperialUnits.AREA_YD2,
    density_lbPerFt3: null,
    width_ft: null,
    thickness_in: null,
    mainline: MainlineOptions.BOTH,
    isDefault: true,
    fromDefault: true,
    description: null,
    quantity: null,
    type: LineItemTypes.HARDCOST,
  },
  {
    id: null,
    name: 'Continuously Reinforced Concrete Slab',
    activity: null,
    unitCost: 65.00,
    unitSystem: UnitSystem.Imperial,
    displayUnits: UnitSystem.Imperial,
    units: ImperialUnits.AREA_YD2,
    density_lbPerFt3: null,
    width_ft: null,
    thickness_in: null,
    mainline: MainlineOptions.BOTH,
    isDefault: true,
    fromDefault: true,
    description: null,
    quantity: null,
    type: LineItemTypes.HARDCOST,
  },
  {
    id: null,
    name: 'Concrete Overlay Slab',
    activity: null,
    unitCost: 50.00,
    unitSystem: UnitSystem.Imperial,
    displayUnits: UnitSystem.Imperial,
    units: ImperialUnits.AREA_YD2,
    density_lbPerFt3: null,
    width_ft: null,
    thickness_in: null,
    mainline: MainlineOptions.BOTH,
    isDefault: true,
    fromDefault: true,
    description: null,
    quantity: null,
    type: LineItemTypes.HARDCOST,
  },

  /*
  Aggregates
   */

  {
    id: null,
    name: 'Asphalt Stabilized Drainage Layer',
    activity: null,
    unitCost: 75,
    unitSystem: UnitSystem.Imperial,
    displayUnits: UnitSystem.Imperial,
    units: ImperialUnits.MASS_SHTN,
    density_lbPerFt3: 146,
    width_ft: null,
    thickness_in: null,
    mainline: MainlineOptions.BOTH,
    isDefault: true,
    fromDefault: true,
    description: null,
    quantity: null,
    type: LineItemTypes.HARDCOST,
  },
  {
    id: null,
    name: 'Cement Stabilized Drainage Layer',
    activity: null,
    unitCost: 75,
    unitSystem: UnitSystem.Imperial,
    displayUnits: UnitSystem.Imperial,
    units: ImperialUnits.MASS_SHTN,
    density_lbPerFt3: 146,
    width_ft: null,
    thickness_in: null,
    mainline: MainlineOptions.BOTH,
    isDefault: true,
    fromDefault: true,
    description: null,
    quantity: null,
    type: LineItemTypes.HARDCOST,
  },
  {
    id: null,
    name: 'Aggregate Drainage Layer',
    activity: null,
    unitCost: 40,
    unitSystem: UnitSystem.Imperial,
    displayUnits: UnitSystem.Imperial,
    units: ImperialUnits.MASS_SHTN,
    density_lbPerFt3: 152,
    width_ft: null,
    thickness_in: null,
    mainline: MainlineOptions.BOTH,
    isDefault: true,
    fromDefault: true,
    description: null,
    quantity: null,
    type: LineItemTypes.HARDCOST,
  },
  {
    id: null,
    name: 'Aggregate Base Material',
    activity: null,
    unitCost: 34.37,
    unitSystem: UnitSystem.Imperial,
    displayUnits: UnitSystem.Imperial,
    units: ImperialUnits.MASS_SHTN,
    density_lbPerFt3: 152,
    width_ft: null,
    thickness_in: null,
    mainline: MainlineOptions.BOTH,
    isDefault: true,
    fromDefault: true,
    description: null,
    quantity: null,
    type: LineItemTypes.HARDCOST,
  },
  {
    id: null,
    name: 'Asphalt Stabilized Aggregate Base Material',
    activity: null,
    unitCost: 65,
    unitSystem: UnitSystem.Imperial,
    displayUnits: UnitSystem.Imperial,
    units: ImperialUnits.MASS_SHTN,
    density_lbPerFt3: 150,
    width_ft: null,
    thickness_in: null,
    mainline: MainlineOptions.BOTH,
    isDefault: true,
    fromDefault: true,
    description: null,
    quantity: null,
    type: LineItemTypes.HARDCOST,
  },
  {
    id: null,
    name: 'Aggregate Sub-Base Material',
    activity: null,
    unitCost: 34.37,
    unitSystem: UnitSystem.Imperial,
    displayUnits: UnitSystem.Imperial,
    units: ImperialUnits.MASS_SHTN,
    density_lbPerFt3: 150,
    width_ft: null,
    thickness_in: null,
    mainline: MainlineOptions.BOTH,
    isDefault: true,
    fromDefault: true,
    description: null,
    quantity: null,
    type: LineItemTypes.HARDCOST,
  },
  {
    id: null,
    name: 'Cement Treated Aggregate',
    activity: null,
    unitCost: 65.00,
    unitSystem: UnitSystem.Imperial,
    displayUnits: UnitSystem.Imperial,
    units: ImperialUnits.MASS_SHTN,
    density_lbPerFt3: 150,
    width_ft: null,
    thickness_in: null,
    mainline: MainlineOptions.BOTH,
    isDefault: true,
    fromDefault: true,
    description: null,
    quantity: null,
    type: LineItemTypes.HARDCOST,
  },
  {
    id: null,
    name: 'Chemically Stabilized Sub-Base Material',
    activity: null,
    unitCost: null,
    unitSystem: UnitSystem.Imperial,
    displayUnits: UnitSystem.Imperial,
    units: ImperialUnits.VOLUME_YD2IN,
    density_lbPerFt3: 150,
    width_ft: null,
    thickness_in: null,
    mainline: MainlineOptions.BOTH,
    isDefault: true,
    fromDefault: true,
    description: null,
    quantity: null,
    type: LineItemTypes.HARDCOST,
  },


  /*
  Operations
   */

  {
    id: null,
    name: 'Milling/Planing AC',
    activity: null,
    unitCost: 1,
    unitSystem: UnitSystem.Imperial,
    displayUnits: UnitSystem.Imperial,
    units: ImperialUnits.VOLUME_YD2IN,
    density_lbPerFt3: null,
    width_ft: null,
    thickness_in: null,
    mainline: MainlineOptions.BOTH,
    isDefault: true,
    fromDefault: true,
    description: null,
    quantity: null,
    type: LineItemTypes.OPERATION,
  },
  {
    id: null,
    name: 'Fracturing PCC',
    activity: null,
    unitCost: 2.30,
    unitSystem: UnitSystem.Imperial,
    displayUnits: UnitSystem.Imperial,
    units: ImperialUnits.AREA_YD2,
    density_lbPerFt3: null,
    width_ft: null,
    thickness_in: null,
    mainline: MainlineOptions.BOTH,
    isDefault: true,
    fromDefault: true,
    description: null,
    quantity: null,
    type: LineItemTypes.OPERATION,
  },
  {
    id: null,
    name: "Patching JPCP (6' x 12')",
    activity: null,
    unitCost: 200,
    unitSystem: UnitSystem.Imperial,
    displayUnits: UnitSystem.Imperial,
    units: ImperialUnits.AREA_YD2,
    density_lbPerFt3: null,
    width_ft: null,
    thickness_in: null,
    mainline: MainlineOptions.BOTH,
    isDefault: true,
    fromDefault: true,
    description: null,
    quantity: null,
    type: LineItemTypes.OPERATION,
  },
  {
    id: null,
    name: "Patching CRCP (6' x 12')",
    activity: null,
    unitCost: 225,
    unitSystem: UnitSystem.Imperial,
    displayUnits: UnitSystem.Imperial,
    units: ImperialUnits.AREA_YD2,
    density_lbPerFt3: null,
    width_ft: null,
    thickness_in: null,
    mainline: MainlineOptions.BOTH,
    isDefault: true,
    fromDefault: true,
    description: null,
    quantity: null,
    type: LineItemTypes.OPERATION,
  },
  {
    id: null,
    name: 'Patching AC',
    activity: null,
    unitCost: 300,
    unitSystem: UnitSystem.Imperial,
    displayUnits: UnitSystem.Imperial,
    units: ImperialUnits.MASS_SHTN,
    density_lbPerFt3: 146,
    width_ft: null,
    thickness_in: null,
    mainline: MainlineOptions.BOTH,
    isDefault: true,
    fromDefault: true,
    description: null,
    quantity: null,
    type: LineItemTypes.OPERATION,
  },
  {
    id: null,
    name: 'Joint Cleaning and Sealing',
    activity: null,
    unitCost: 2,
    unitSystem: UnitSystem.Imperial,
    displayUnits: UnitSystem.Imperial,
    units: ImperialUnits.LENGTH_FT,
    density_lbPerFt3: null,
    width_ft: null,
    thickness_in: null,
    mainline: MainlineOptions.BOTH,
    isDefault: true,
    fromDefault: true,
    description: null,
    quantity: null,
    type: LineItemTypes.OPERATION,
  },
  {
    id: null,
    name: 'PCC Grinding',
    activity: null,
    unitCost: 3,
    unitSystem: UnitSystem.Imperial,
    displayUnits: UnitSystem.Imperial,
    units: ImperialUnits.AREA_YD2,
    density_lbPerFt3: null,
    width_ft: null,
    thickness_in: null,
    mainline: MainlineOptions.BOTH,
    isDefault: true,
    fromDefault: true,
    description: null,
    quantity: null,
    type: LineItemTypes.OPERATION,
  },
  {
    id: null,
    name: 'Surface Treatment',
    activity: null,
    unitCost: 2,
    unitSystem: UnitSystem.Imperial,
    displayUnits: UnitSystem.Imperial,
    units: ImperialUnits.AREA_YD2,
    density_lbPerFt3: null,
    width_ft: null,
    thickness_in: null,
    mainline: MainlineOptions.BOTH,
    isDefault: true,
    fromDefault: true,
    description: null,
    quantity: null,
    type: LineItemTypes.OPERATION,
  },
  {
    id: null,
    name: 'Preventative Maintenance Overlay',
    activity: null,
    unitCost: 6.50,
    unitSystem: UnitSystem.Imperial,
    displayUnits: UnitSystem.Imperial,
    units: ImperialUnits.AREA_YD2,
    density_lbPerFt3: null,
    width_ft: null,
    thickness_in: null,
    mainline: MainlineOptions.BOTH,
    isDefault: true,
    fromDefault: true,
    description: null,
    quantity: null,
    type: LineItemTypes.OPERATION,
  },
  {
    id: null,
    name: 'Asphalt Pavement Removal',
    activity: null,
    unitCost: 0.375,
    unitSystem: UnitSystem.Imperial,
    displayUnits: UnitSystem.Imperial,
    units: ImperialUnits.VOLUME_YD2IN,
    density_lbPerFt3: null,
    width_ft: null,
    thickness_in: null,
    mainline: MainlineOptions.BOTH,
    isDefault: true,
    fromDefault: true,
    description: null,
    quantity: null,
    type: LineItemTypes.OPERATION,
  },
  {
    id: null,
    name: 'Concrete/Composite Pavement Removal',
    activity: null,
    unitCost: 0.7167,
    unitSystem: UnitSystem.Imperial,
    displayUnits: UnitSystem.Imperial,
    units: ImperialUnits.VOLUME_YD2IN,
    density_lbPerFt3: null,
    width_ft: null,
    thickness_in: null,
    mainline: MainlineOptions.BOTH,
    isDefault: true,
    fromDefault: true,
    description: null,
    quantity: null,
    type: LineItemTypes.OPERATION,
  },
  {
    id: null,
    name: 'Custom',
    activity: null,
    unitCost: null,
    unitSystem: UnitSystem.Imperial,
    displayUnits: UnitSystem.Imperial,
    units: ImperialUnits.UNITS,
    density_lbPerFt3: null,
    width_ft: null,
    thickness_in: null,
    mainline: MainlineOptions.BOTH,
    isDefault: true,
    fromDefault: true,
    description: null,
    quantity: null,
    type: LineItemTypes.HARDCOST,
  },
  {
    id: null,
    name: 'Custom',
    activity: null,
    unitCost: null,
    unitSystem: UnitSystem.Imperial,
    displayUnits: UnitSystem.Imperial,
    units: ImperialUnits.UNITS,
    density_lbPerFt3: null,
    width_ft: null,
    thickness_in: null,
    mainline: MainlineOptions.BOTH,
    isDefault: true,
    fromDefault: false,
    description: null,
    quantity: null,
    type: LineItemTypes.OPERATION,
  },
];
